{
  "mainMenu": [
    {
      "id": "0",
      "icon": "bi-buildings",
      "title": "Organizations",
      "desc": "Add new organization details",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": true,
      "for_module": false,
      "optClick": "org",
      "clrCode": "#38D5BE",
      "component": "OrgListComponent"
    },
    {
      "id": "1",
      "icon": "bi-building",
      "title": "Institutes Details",
      "desc": "Add new Institutes details",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "int",
      "clrCode": "#34A6F4",
      "component": "InstListComponent"
    },
    {
      "id": "2",
      "icon": "bi-journal-text",
      "title": "Inquery Form",
      "desc": "Add students inquery details",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "inq",
      "clrCode": "#5EA529",
      "component": "OrgListComponent"
    },
    {
      "id": "3",
      "icon": "bi-window-stack",
      "title": "Demo Requests",
      "desc": "Approve/Reject Demo Requests",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": true,
      "for_module": false,
      "optClick": "dmo",
      "clrCode": "#A6A09B",
      "component": "DemoListComponent"
    },
    {
      "id": "4",
      "icon": "bi-ui-checks-grid",
      "title": "Modules Master",
      "desc": "Add service modules to sell",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": true,
      "for_module": false,
      "optClick": "mod",
      "clrCode": "#FB64CF",
      "component": "ModulesComponent"
    },
    {
      "id": "5",
      "icon": "bi-tags",
      "title": "Coupons Master",
      "desc": "Add discount coupons for selling offers",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": true,
      "for_module": false,
      "optClick": "cpn",
      "clrCode": "#FB6400",
      "component": "CouponsComponent"
    },
    {
      "id": "10",
      "icon": "bi-telephone-plus",
      "title": "Telephone Directory",
      "desc": "Manage Important Phone Numbers",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "tel",
      "clrCode": "#3BB8DB",
      "component": "TelephoneDirectoryComponent"
    },
    {
      "id": "11",
      "icon": "bi-list-ol",
      "title": "Time Table",
      "desc": "Manage Teachers & Students Time-table",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "ttl",
      "clrCode": "#C27AFF",
      "component": "TimetableComponent"
    },
    {
      "id": "12",
      "icon": "bi-person-video3",
      "title": "Staff Members",
      "desc": "Manage all Staff Members",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "stf",
      "clrCode": "#21BCFF",
      "component": "StaffListComponent"
    },
    {
      "id": "13",
      "icon": "bi-file-ruled",
      "title": "Account Ledger",
      "desc": "Manage Account Ledger",
      "locked": false,
      "passcode": true,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "mal",
      "clrCode": "#37BC7D",
      "component": "Finance"
    },
    {
      "id": "14",
      "icon": "bi-person-walking",
      "title": "Gate Pass",
      "desc": "Student Verification & Gate Pass",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "sgp",
      "clrCode": "#51A2FF",
      "component": "GatePass"
    },
    {
      "id": "15",
      "icon": "bi-file-earmark-bar-graph",
      "title": "Reports",
      "desc": "View Conditional Reports",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "rpt",
      "clrCode": "#05DF72",
      "component": ""
    },
    {
      "id": "16",
      "icon": "bi-person-check",
      "title": "Std. Attendance",
      "desc": "Manage Students Daily Attendance",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "att",
      "clrCode": "#FF692A",
      "component": "Attendance"
    },
    {
      "id": "17",
      "icon": "bi-bus-front",
      "title": "Transport",
      "desc": "Manage Transport & Routs",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "trp",
      "clrCode": "#F0B13B",
      "component": "Transport"
    },
    {
      "id": "18",
      "icon": "bi-person-gear",
      "title": "Manage Users",
      "desc": "Manage Users & Permissions",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "usr",
      "clrCode": "#7CCF35",
      "component": "UserListComponent"
    },
    {
      "id": "018",
      "icon": "bi-person-gear",
      "title": "Manage Users",
      "desc": "Manage Users & Permissions",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": true,
      "for_module": false,
      "optClick": "usr",
      "clrCode": "#7CCF35",
      "component": "UserListComponent"
    },
    {
      "id": "19",
      "icon": "bi-file-earmark-person",
      "title": "Admission Form",
      "desc": "New students entry details form",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "adf",
      "clrCode": "#FB64B6",
      "component": "AdmissionListComponent"
    },
    {
      "id": "20",
      "icon": "bi-wallet2",
      "title": "Eligibility Setup",
      "desc": "Define Student Eligibility Rules",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "slg",
      "clrCode": "#FF8904",
      "component": "EligibilitySetup"
    },
    {
      "id": "21",
      "icon": "bi-printer",
      "title": "Inventory Management",
      "desc": "Track stock/orders management",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "inv",
      "clrCode": "#37BC7D",
      "component": "Inventory"
    },
    {
      "id": "22",
      "icon": "bi-receipt",
      "title": "Receipt Vouchers",
      "desc": "Manage Receipts & Vouchers",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "mrv",
      "clrCode": "#2984D1",
      "component": ""
    },
    {
      "id": "23",
      "icon": "bi-file-earmark-ruled",
      "title": "Payment Vouchers",
      "desc": "Manage New Payments",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "mnp",
      "clrCode": "#8E51FF",
      "component": ""
    },
    {
      "id": "24",
      "icon": "bi-card-checklist",
      "title": "Fees Management",
      "desc": "Manage Students Fees",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "fee",
      "clrCode": "#669944",
      "component": "FeeManagement"
    },
    {
      "id": "25",
      "icon": "bi-file-earmark-text",
      "title": "Home Work",
      "desc": "Assign student home work",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "shw",
      "clrCode": "#2C92B8",
      "component": "Homework"
    },
    {
      "id": "26",
      "icon": "bi-bag-plus",
      "title": "Student Ledger",
      "desc": "Manage Students Account",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "msa",
      "clrCode": "#D0872E",
      "component": ""
    },
    {
      "id": "27",
      "icon": "bi-people",
      "title": "Students List",
      "desc": "View All Students List",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "vsl",
      "clrCode": "#FF6467",
      "component": ""
    },
    {
      "id": "28",
      "icon": "bi-boxes",
      "title": "Package Master",
      "desc": "Manage Plan/Packages",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": true,
      "for_module": false,
      "optClick": "pkg",
      "clrCode": "#FF6467",
      "component": ""
    },
    {
      "id": "29",
      "icon": "bi-person-gear",
      "title": "Application Form",
      "desc": "Manage New Applications",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": false,
      "optClick": "apl",
      "clrCode": "#7CCF35",
      "component": "ApplicationListComponent"
    },
    {
      "id": "30",
      "icon": "bi-book",
      "title": "Library",
      "desc": "Library Management System",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "lib",
      "clrCode": "#2984D1",
      "component": "Library"
    },
    {
      "id": "31",
      "icon": "bi-receipt",
      "title": "Examination",
      "desc": "Manage Student Examination",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "xam",
      "clrCode": "#2984D1",
      "component": "Examination"
    },
    {
      "id": "32",
      "icon": "bi-file-earmark-ppt",
      "title": "HR Admin",
      "desc": "HR Management System",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": false,
      "for_module": true,
      "optClick": "hra",
      "clrCode": "#2C92B8",
      "component": "HrAdminComponent"
    },
    {
      "id": "33",
      "icon": "bi-envelope-paper",
      "title": "Messages",
      "desc": "Contact Messages from Website",
      "locked": false,
      "passcode": false,
      "hidden": false,
      "sa_only": true,
      "for_module": false,
      "optClick": "cmsg",
      "clrCode": "#2C92B8",
      "component": "ContactMessages"
    }
  ],
  "boxMenu_sa": [
    {
      "id": "2",
      "mmid": "3",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "4",
      "mmid": "018",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "1",
      "mmid": "12",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "5",
      "mmid": "0",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "7",
      "mmid": "4",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "8",
      "mmid": "5",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "11",
      "mmid": "28",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "12",
      "mmid": "33",
      "ur_icon": "",
      "ur_clrCode": ""
    }
  ],
  "boxMenu_adm": [
    {
      "id": "1",
      "mmid": "1",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "10",
      "mmid": "12",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "16",
      "mmid": "11",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "3",
      "mmid": "18",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "6",
      "mmid": "2",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "13",
      "mmid": "29",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "12",
      "mmid": "19",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "15",
      "mmid": "16",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "14",
      "mmid": "24",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "17",
      "mmid": "17",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "18",
      "mmid": "30",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "19",
      "mmid": "31",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "20",
      "mmid": "14",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "22",
      "mmid": "21",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "23",
      "mmid": "32",
      "ur_icon": "",
      "ur_clrCode": ""
    }, {
      "id": "24",
      "mmid": "25",
      "ur_icon": "",
      "ur_clrCode": ""
    }
  ],
  "topMenu": [
    {
      "menuTitle": "Masters",
      "is_active": true,
      "menuOpts": [
        {"mmid": "0"},
        {"mmid": "1"},
        {"mmid": "2"},
        {"mmid": "3"},
        {"mmid": "18"}
      ]
    },
    {
      "menuTitle": "Reception",
      "is_active": false,
      "menuOpts": []
    },
    {
      "menuTitle": "Fees",
      "is_active": false,
      "menuOpts": []
    },
    {
      "menuTitle": "Transactions",
      "is_active": false,
      "menuOpts": []
    },
    {
      "menuTitle": "Accounts",
      "is_active": false,
      "menuOpts": []
    },
    {
      "menuTitle": "Reports",
      "is_active": false,
      "menuOpts": []
    }
  ],
  "sideMenu": [
    {
      "menuTitle": "Masters",
      "menuOpts": [
        {
          "mmid": "1"
        },
        {
          "mmid": "1"
        },
        {
          "mmid": "1"
        },
        {
          "mmid": "1"
        }
      ]
    },
    {
      "menuTitle": "Fees",
      "menuOpts": []
    },
    {
      "menuTitle": "Attendance",
      "menuOpts": []
    },
    {
      "menuTitle": "Reception",
      "menuOpts": []
    },
    {
      "menuTitle": "Accounts",
      "menuOpts": []
    },
    {
      "menuTitle": "Extras",
      "menuOpts": []
    }
  ]
}
